module.exports = __webpack_public_path__ + "static/img/pic5.2dc1b0e7.png";